import { Link } from "react-router-dom"
import "./HypertensionPage.css"

const services = [
  { name: "Blood Pressure Check", description: "Accurate measurement using calibrated professional equipment" },
  { name: "Lifestyle Advice", description: "Guidance on diet, exercise, and habits to manage blood pressure" },
  { name: "GP Referral", description: "If needed, we'll refer you to your GP for further assessment" },
  { name: "Ongoing Monitoring", description: "Regular checks to track your blood pressure over time" },
]

const faqs = [
  {
    question: "What is hypertension case finding?",
    answer: "Hypertension case finding is an NHS service where pharmacies help identify people with high blood pressure who may not know they have it. Early detection is crucial for preventing serious health problems like heart disease and stroke."
  },
  {
    question: "Who should get their blood pressure checked?",
    answer: "Anyone aged 40 or over who is not currently on any blood pressure medication can have a free NHS blood pressure check. If you have risk factors such as being overweight, having a family history of high blood pressure, or leading a sedentary lifestyle, more frequent checks are recommended."
  },
  {
    question: "What happens during the check?",
    answer: "Our pharmacist will take your blood pressure using professional equipment. This is painless and takes just a few minutes. They'll explain your reading and what it means for your health."
  },
  {
    question: "What if my blood pressure is high?",
    answer: "If your reading is elevated, we may recommend ambulatory blood pressure monitoring (ABPM) or home monitoring before making any conclusions. If hypertension is confirmed, we'll refer you to your GP for appropriate treatment."
  },
  {
    question: "Is this service free?",
    answer: "Yes, this is a free NHS service. We're committed to helping identify people with undiagnosed high blood pressure to prevent serious health complications."
  },
]

function HypertensionPage() {
  return (
    <div className="hypertension-page">
      <section className="ht-hero">
        <h1>Blood Pressure Checks</h1>
        <p className="ht-tagline">
          Blood pressure monitoring and cardiovascular health screening
        </p>
      </section>

      <section className="ht-intro">
        <p>
          High blood pressure often has no symptoms but can lead to serious health problems if left
          untreated. Our hypertension case finding service helps identify people who may be at risk.
        </p>
        <p>
          Anyone aged 40 or over who is not currently on any blood pressure medication can have a
          free NHS blood pressure check at our pharmacy.
        </p>
        <p>
          Our trained pharmacists can check your blood pressure and provide advice on how to
          maintain healthy blood pressure levels.
        </p>
        <p className="ht-highlight">
          Free NHS service - early detection can save lives.
        </p>
      </section>

      <section className="ht-services">
        <h2>What We Offer</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                  <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
                </svg>
              </div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="ht-cta">
        <h2>Ready to Get Started?</h2>
        <p>
          Book a blood pressure check with our pharmacist. It only takes a few minutes and could
          help identify a serious health risk before it's too late.
        </p>
        <Link to="/services?service=hypertension" className="button primary">
          Book a Consultation
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </Link>
      </section>

      <section className="ht-faq">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default HypertensionPage
